import React from 'react'
import {
  Route,
  Redirect,
  IndexRoute,
} from 'react-router'

import init from './init'
import Master from './containers/Master'
import HomePage from './containers/HomePage'
import NewsPage from './containers/NewsPage'
import TimelinePage from './containers/TimelinePage'
import FAStoryPage from './containers/FAStoryPage'
import RoutePage from './containers/RoutePage'
import SpherePage from './containers/SpherePage'

const Routes = (
    <Route path="/" component={Master}>
      <IndexRoute component={HomePage} />
      <Route path="home" component={HomePage} />
      <Route path="news" component={NewsPage} />
      <Route path="timeline" component={TimelinePage} />
      <Route path="fastory" component={FAStoryPage} />
      <Route path="sphere">
        <Route path=":regionId" component={SpherePage} />
      </Route>
      <Route path="region">
        <Route path=":regionId" component={RoutePage} />
      </Route>
      <Redirect path="*" to="/" />
    </Route>
)

init(Routes)


/** WEBPACK FOOTER **
 ** ./src/app/app.js
 **/